/*
 * HelianWell — cart drawer upsell interactions (arrows + add shimmer).
 * Loaded once globally from layout/theme.liquid so the delegated listener is
 * always registered — independent of cart state. (Previously this lived in an
 * inline <script> inside the upsell snippet, which only renders when the cart
 * has items; when the drawer is morphed in via the Section Rendering API, inline
 * scripts don't execute, so the arrows never got wired up on the storefront.)
 * Delegation on `document` means it keeps working across every drawer morph.
 */
(function () {
  if (window.__hwCartUpsell) return;
  window.__hwCartUpsell = true;

  document.addEventListener('click', function (event) {
    // Arrows: scroll the track one card at a time.
    var arrow = event.target.closest('[data-hw-upsell-prev], [data-hw-upsell-next]');
    if (arrow) {
      var upsell = arrow.closest('[data-hw-upsell]');
      var track = upsell && upsell.querySelector('.hw-cart-upsell__track');
      if (track) {
        var card = track.querySelector('.hw-cart-upsell__card');
        var step = card ? card.offsetWidth + 10 : track.clientWidth;
        var dir = arrow.hasAttribute('data-hw-upsell-next') ? 1 : -1;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    // Skeleton shimmer on the card while the add request runs; the drawer
    // morph replaces the DOM when the cart updates.
    var addButton = event.target.closest('.hw-cart-upsell__add');
    if (addButton && !addButton.disabled) {
      var upsellCard = addButton.closest('.hw-cart-upsell__card');
      if (upsellCard) upsellCard.classList.add('is-adding');
    }
  });
})();
